/**
 * Team color constants for USA vs EUR teams
 * Used across the application for consistent team branding
 */

export const TEAM_COLORS = {
  USA: {
    primary: 'rgb(200, 20, 20)',
    hex: '#C81414',
    name: 'USA Red',
  },
  EUR: {
    primary: 'rgb(0, 60, 130)',
    hex: '#003C82',
    name: 'Europe Blue',
  },
  TIED: {
    primary: '#d0d0d0',
    hex: '#d0d0d0',
    name: 'Tie Gray',
  },
} as const;

/**
 * Helper function to get team color by team code
 */
export const getTeamColor = (team: string | undefined): string => {
  if (team === 'USA') return TEAM_COLORS.USA.primary;
  if (team === 'EUR') return TEAM_COLORS.EUR.primary;
  return TEAM_COLORS.TIED.primary;
};
